import Bullet from 'assets/imgs/svg/bullet.svg';
import BlogActionBG from 'assets/imgs/webp/blog-action.webp';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

export const ActionContainer = styled.section`
  --step-0: clamp(12rem, calc(10.4rem + 0.5vw), 18rem);
  --font: myfontfour;

  display: flex;
  flex-direction: column;
`;

export const ActionButtonSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16rem;
  width: 100%;
  height: 158px;
  background: center / cover no-repeat url(${BlogActionBG});

  padding: 40rem;
  margin: 12px 0;
`;

export const SVGIcon = styled.div`
  width: 40rem;
  height: 40rem;
  border-radius: 80%;

  & > img {
    width: 100%;
    height: 100%;
  }
`;

export const ActionButton = styled(Link)`
  padding: 1em 2em;

  background: #ffffff;
  border-radius: 0.5em;

  font-family: var(--font);

  font-weight: 700;
  font-size: 1.325em;

  text-align: center;

  color: #07080a;
  display: flex;
  align-items: center;
  ${flexGap('8rem')}

  &:hover {
    ${SVGIcon} {
      & > img {
        transform: scale(1.02);
        filter: brightness(0) invert(1);
      }
      transition: background-color 0.5s ease;

      background-color: black;
    }
    text-emphasis: none;
    text-decoration: none;
    color: black;
  }
`;

export const ActionBannerHeader = styled.h3`
  margin: 0;
  font-family: var(--font);
  font-weight: 700;
  font-size: 1.8em;
  color: #ffffff;
`;

export const StyledLink = styled(Link)`
  text-decoration: underline;
  font-weight: 700;
  color: #0063db;
  /* padding: 0 0.3125em; */
`;

export const ActionList = styled.ul`
  list-style: inside url(${Bullet});

  & > li {
    list-style: none;
    background: url(${Bullet}) no-repeat left;
    background-size: 1%;
    padding: 0.5em 0px 0.5em 1em;
    vertical-align: middle;

    /* reset styles (optional): */
    list-style: none;
    margin: 0;
    line-height: 1.5;

    vertical-align: middle;
    font-size: var(--step-0);
    font-family: var(--font);
  }
`;
